export default __webpack_public_path__ + "static/media/Astro_Sagittarius_Black.df61eaa9.png";